<template>
  <div class="rupturas-hierarquia">
    <configurador-niveis
        :presets="presetsPrincipais"
        :preset-ativo="presetAtivo"
        :niveis-selecionados="niveisSelecionados"
        :dimensoes="DIMS"
        :modo-grupos="modoGrupos"
        :total-grupos="gruposRaiz.length"
        :total-produtos="totalProdutosOriginal"
        :total-produtos-filtrados="totalProdutosFiltrados"
        :total-filtros-ativos="totalFiltrosAtivos"
        :label-nivel0="labelNivel0"
        @aplicar-preset="aplicarPreset"
        @abrir-custom="abrirCustom"
        @alterar-nivel="alterarNivel"
        @adicionar-nivel="adicionarNivel"
        @remover-nivel="removerNivel"
        @limpar-filtros="limparTodosFiltros"
        @colapsar-todos="colapsarTodos"
    />

    <tabela-rupturas
        :linhas="linhasVisiveis"
        :modo-grupos="modoGrupos"
        :mapa-grupos="mapaGrupos"
        :expandidos="expandidos"
        :loading="loading"
        :total-produtos="produtos.length"
        :pagina-flat="paginaFlat"
        :total-paginas-flat="totalPaginasFlat"
        :filtros-grupo="filtrosGrupo"
        :filtros-produto="filtrosProduto"
        :ordenacao-por-campo="ordenacaoPorCampo"
        :valores-unicos-grupo="valoresUnicosGrupo"
        :valores-unicos-produto="valoresUnicosProduto"
        :dimensoes="DIMS"
        :fmt="fmt"
        :fmt-pct="fmtPct"
        :pct-color="pctColor"
        :pct-cls="pctCls"
        :status-label="statusLabel"
        :status-color="statusColor"
        @toggle-expandido="toggleExpandido"
        @ir-para-pagina-flat="irParaPaginaFlat"
        @ir-para-pagina-grupo="irParaPaginaGrupo"
        @aplicar-filtro-grupo="aplicarFiltroGrupo"
        @aplicar-filtro-produto="aplicarFiltroProduto"
        @limpar-filtro-grupo="limparFiltroGrupo"
        @limpar-filtro-produto="limparFiltroProduto"
        @ordenar="aplicarOrdenacaoEFechar"
    />
  </div>
</template>

<script>
import ConfiguradorNiveis from './ConfiguradorNiveis.vue';
import TabelaRupturas from './TabelaRupturas.vue';

const DIMS = {
  filial:     { key: 'filial',     label: 'Filial',      icon: 'mdi-office-building', idF: 'filial_id',     nomeF: 'filial',     color: '#023449', chipBg: '#e0f2fe', chipTxt: '#0c4a6e' },
  categoria:  { key: 'categoria',  label: 'Categoria',   icon: 'mdi-tag-multiple',    idF: 'categoria_id',  nomeF: 'categoria',  color: '#7c3aed', chipBg: '#ede9fe', chipTxt: '#5b21b6' },
  fornecedor: { key: 'fornecedor', label: 'Fornecedor',  icon: 'mdi-truck-outline',   idF: 'fornecedor_id', nomeF: 'fornecedor', color: '#c2410c', chipBg: '#ffedd5', chipTxt: '#9a3412' },
};

const PRESETS_PRINCIPAIS = [
  { id: 'so-fil',   label: 'Filiais',      icon: 'mdi-office-building', niveis: ['filial']      },
  { id: 'so-forn',  label: 'Fornecedores', icon: 'mdi-truck-outline',   niveis: ['fornecedor']  },
  { id: 'so-cat',   label: 'Categorias',   icon: 'mdi-tag-multiple',    niveis: ['categoria']   },
  { id: 'so-prod',  label: 'Produtos',     icon: 'mdi-package-variant', niveis: []              },
];

const STATUS_EXCLUIDOS = new Set([
  'FORA DE LINHA',
]);

export default {
  name: 'RupturasHierarquia',

  components: {
    ConfiguradorNiveis,
    TabelaRupturas,
  },

  props: {
    produtos:     { type: Array,   default: () => [] },
    filiais:      { type: Array,   default: () => [] },
    categorias:   { type: Array,   default: () => [] },
    fornecedores: { type: Array,   default: () => [] },
    loading:      { type: Boolean, default: false     },
  },

  data() {
    return {
      DIMS,
      presetsPrincipais:  PRESETS_PRINCIPAIS,
      presetAtivo:        'so-fil',
      niveisSelecionados: ['filial'],
      expandidos:         new Set(),
      sortField:          'faltante',
      sortAsc:            false,
      sortProdField:      'custo_faltante',
      sortProdAsc:        false,
      paginaFlat:         1,
      paginasGrupo:       {},
      itensPorPagina:     50,
      mapaGrupos:         new Map(),

      filtrosGrupo: {
        nome:         [],
        skus_ativos:  { min: null, max: null },
        skus_ruptura: { min: null, max: null },
        necessidade:  { min: null, max: null },
        atendido:     { min: null, max: null },
        faltante:     { min: null, max: null },
        pct_skus:     { min: null, max: null },
        pct_rs:       { min: null, max: null },
      },

      filtrosProduto: {
        descricao_produto:   [],
        data_movimento:      [],
        origem:              [],
        custo_solicitado:    { min: null, max: null },
        custo_atendido:      { min: null, max: null },
        custo_faltante:      { min: null, max: null },
        percentual_atendido: { min: null, max: null },
        status_principal:    [],
      },

      ordenacaoPorCampo: {
        nome: null,
        skus_ativos: null,
        skus_ruptura: null,
        necessidade: null,
        atendido: null,
        faltante: null,
        pct_skus: null,
        pct_rs: null,
        descricao_produto: null,
        data_movimento: null,
        origem: null,
        custo_solicitado: null,
        custo_atendido: null,
        custo_faltante: null,
        percentual_atendido: null,
        status_principal: null,
      },
    };
  },

  computed: {
    niveisConfig() {
      return this.niveisSelecionados.map(k => DIMS[k]);
    },

    modoGrupos() {
      return this.niveisSelecionados.length > 0;
    },

    labelNivel0() {
      if (!this.niveisSelecionados.length) return 'produtos';
      const d = DIMS[this.niveisSelecionados[0]];
      return d ? d.label.toLowerCase() + 's' : 'grupos';
    },

    totalFiltrosAtivos() {
      let count = 0;

      Object.values(this.filtrosGrupo).forEach(valor => {
        if (Array.isArray(valor)) {
          if (valor.length > 0) count++;
        } else if (typeof valor === 'object' && valor !== null) {
          if ((valor.min !== null && valor.min !== undefined && valor.min !== '') ||
              (valor.max !== null && valor.max !== undefined && valor.max !== '')) {
            count++;
          }
        }
      });

      Object.values(this.filtrosProduto).forEach(valor => {
        if (Array.isArray(valor)) {
          if (valor.length > 0) count++;
        } else if (typeof valor === 'object' && valor !== null) {
          if ((valor.min !== null && valor.min !== undefined && valor.min !== '') ||
              (valor.max !== null && valor.max !== undefined && valor.max !== '')) {
            count++;
          }
        }
      });

      return count;
    },

    gruposRaiz() {
      if (!this.niveisSelecionados.length) return [];

      const primeiroNivel = this.niveisSelecionados[0];

      if (this.niveisSelecionados.length === 1) {
        switch(primeiroNivel) {
          case 'filial':
            if (this.filiais && this.filiais.length) {
              const grupos = this.aplicarFiltrosGrupos(this.converterFiliais(this.filiais));
              this.construirMapaGrupos(grupos);
              return grupos;
            }
            break;
          case 'categoria':
            if (this.categorias && this.categorias.length) {
              const grupos = this.aplicarFiltrosGrupos(this.converterCategorias(this.categorias));
              this.construirMapaGrupos(grupos);
              return grupos;
            }
            break;
          case 'fornecedor':
            if (this.fornecedores && this.fornecedores.length) {
              const grupos = this.aplicarFiltrosGrupos(this.converterFornecedores(this.fornecedores));
              this.construirMapaGrupos(grupos);
              return grupos;
            }
            break;
        }
      }

      const grupos = this.aplicarFiltrosGrupos(this.agrupar(this.produtos, 0));
      this.construirMapaGrupos(grupos);
      return grupos;
    },

    gruposRaizOrdenados() {
      return this.ordenar(this.gruposRaiz);
    },

    produtosFlatOrdenados() {
      if (this.niveisSelecionados.length) return [];
      const produtosFiltrados = this.aplicarFiltrosProdutos(this.produtos);
      const f    = this.sortProdField;
      const mult = this.sortProdAsc ? 1 : -1;
      return [...produtosFiltrados].sort((a, b) => {
        const va = a[f] ?? '';
        const vb = b[f] ?? '';
        return va < vb ? -mult : va > vb ? mult : 0;
      });
    },

    totalPaginasFlat() {
      return Math.max(1, Math.ceil(this.produtosFlatOrdenados.length / this.itensPorPagina));
    },

    linhasVisiveis() {
      if (!this.niveisSelecionados.length) {
        const inicio = (this.paginaFlat - 1) * this.itensPorPagina;
        return this.produtosFlatOrdenados.slice(inicio, inicio + this.itensPorPagina).map(p => ({
          tipo:             'produto',
          uid:              `prod-flat-${p.subproduto_id}-${p.data_movimento}-${p.id_abastecimento ?? 'x'}`,
          nivel:            0,
          codigo:           p.codigo_produto,
          descricao:        p.descricao_produto,
          status_principal: p.status_principal,
          status_flags:     p.status_flags,
          origem:           p.origem,
          acao_comprador:   p.acao_comprador,
          data_mov:         p.data_movimento,
          qtd_faltante:     p.qtd_faltante      || 0,
          custo_solicitado: p.custo_solicitado   || 0,
          custo_atendido:   p.custo_atendido     || 0,
          custo_faltante:   p.custo_faltante     || 0,
          pct_atendido:     p.percentual_atendido || 0,
          id_abastecimento: p.id_abastecimento,
          id_pedido:        p.id_pedido || null,
        }));
      }

      const linhas = [];
      this.achatar(this.gruposRaizOrdenados, linhas, 0);
      return linhas;
    },

    totalProdutosFiltrados() {
      if (!this.niveisSelecionados.length) {
        return this.produtosFlatOrdenados.length;
      }

      const contarProdutos = (grupos) => {
        let total = 0;
        for (const grupo of grupos) {
          if (grupo.filhos && grupo.filhos.length > 0) {
            total += contarProdutos(grupo.filhos);
          } else if (grupo.leafProds) {
            const produtosFiltrados = this.aplicarFiltrosProdutos(grupo.leafProds);
            total += produtosFiltrados.length;
          }
        }
        return total;
      };

      return contarProdutos(this.gruposRaiz);
    },

    totalProdutosOriginal() {
      return this.produtos.length;
    },

    temFiltrosAtivos() {
      return this.totalFiltrosAtivos > 0;
    },
  },

  methods: {
    converterFiliais(filiaisBackend) {
      return filiaisBackend.map(f => {
        const prodsFiltrados = this.produtos.filter(p => p.filial_id === f.filial_id);
        return {
          tipo: 'grupo',
          uid: `filial-${f.filial_id}-n0`,
          nivel: 0,
          nome: f.filial,
          dim: 'filial',
          totalProdutos: prodsFiltrados.length,
          filhos: this.niveisSelecionados.length > 1 ? this.agrupar(prodsFiltrados, 1) : [],
          leafProds: this.niveisSelecionados.length === 1 ? prodsFiltrados : [],
          skus_ativos: f.qtd_skus_ativos,
          skus_ruptura: f.qtd_skus_ruptura,
          necessidade: f.necessidade_real,
          atendido: f.tt_atendidos,
          faltante: f.itens_em_rupturas,
          pct_skus: f.percentual_ruptura_skus,
          pct_rs: f.percentual_ruptura_rs,
        };
      });
    },

    converterCategorias(categoriasBackend) {
      return categoriasBackend.map(c => {
        const prodsFiltrados = this.produtos.filter(p => p.categoria_id === c.categoria_id);
        return {
          tipo: 'grupo',
          uid: `categoria-${c.categoria_id}-n0`,
          nivel: 0,
          nome: c.categoria,
          dim: 'categoria',
          totalProdutos: prodsFiltrados.length,
          filhos: this.niveisSelecionados.length > 1 ? this.agrupar(prodsFiltrados, 1) : [],
          leafProds: this.niveisSelecionados.length === 1 ? prodsFiltrados : [],
          skus_ativos: c.qtd_skus_ativos,
          skus_ruptura: c.qtd_skus_ruptura,
          necessidade: c.necessidade_real,
          atendido: c.tt_atendidos,
          faltante: c.itens_nao_atendidos,
          pct_skus: c.percentual_ruptura_skus,
          pct_rs: c.percentual_ruptura_rs,
        };
      });
    },

    converterFornecedores(fornecedoresBackend) {
      return fornecedoresBackend.map(f => {
        const prodsFiltrados = this.produtos.filter(p => p.fornecedor_id === f.fornecedor_id);
        return {
          tipo: 'grupo',
          uid: `fornecedor-${f.fornecedor_id}-n0`,
          nivel: 0,
          nome: f.fornecedor,
          dim: 'fornecedor',
          totalProdutos: prodsFiltrados.length,
          filhos: this.niveisSelecionados.length > 1 ? this.agrupar(prodsFiltrados, 1) : [],
          leafProds: this.niveisSelecionados.length === 1 ? prodsFiltrados : [],
          skus_ativos: f.qtd_skus_ativos,
          skus_ruptura: f.qtd_skus_ruptura,
          necessidade: f.necessidade_real,
          atendido: f.tt_atendidos,
          faltante: f.itens_nao_atendidos,
          pct_skus: f.percentual_ruptura_skus,
          pct_rs: f.percentual_ruptura_rs,
        };
      });
    },

    construirMapaGrupos(grupos) {
      for (const grupo of grupos) {
        this.mapaGrupos.set(grupo.uid, grupo);
        if (grupo.filhos && grupo.filhos.length > 0) {
          this.construirMapaGrupos(grupo.filhos);
        }
      }
    },

    aplicarPreset(preset) {
      this.niveisSelecionados = [...preset.niveis];
      this.presetAtivo        = preset.id;
      this.expandidos         = new Set();
      this.resetarPaginacao();
    },

    abrirCustom() {
      if (!this.niveisSelecionados.length) this.niveisSelecionados = ['filial'];
      this.presetAtivo = 'custom';
      this.expandidos  = new Set();
      this.resetarPaginacao();
    },

    alterarNivel(idx, val) {
      const n = [...this.niveisSelecionados];
      n[idx] = val;
      this.niveisSelecionados = n;
      this.expandidos = new Set();
      this.resetarPaginacao();
    },

    adicionarNivel() {
      const usadas    = new Set(this.niveisSelecionados);
      const disponivel = Object.keys(DIMS).find(k => !usadas.has(k));
      if (disponivel) {
        this.niveisSelecionados = [...this.niveisSelecionados, disponivel];
        this.expandidos = new Set();
      }
    },

    removerNivel() {
      if (this.niveisSelecionados.length > 1) {
        this.niveisSelecionados = this.niveisSelecionados.slice(0, -1);
        this.expandidos = new Set();
      }
    },

    aplicarFiltroGrupo(campo, valor) {
      this.$set(this.filtrosGrupo, campo, valor);
      this.resetarPaginacao();
    },

    limparFiltroGrupo(campo) {
      if (Array.isArray(this.filtrosGrupo[campo])) {
        this.$set(this.filtrosGrupo, campo, []);
      } else {
        this.$set(this.filtrosGrupo, campo, { min: null, max: null });
      }
      this.resetarPaginacao();
    },

    aplicarOrdenacaoEFechar(campo, direcao) {
      this.aplicarOrdenacao(campo, direcao);
    },

    aplicarFiltroProduto(campo, valor) {
      this.$set(this.filtrosProduto, campo, valor);
      this.resetarPaginacao();
    },

    limparFiltroProduto(campo) {
      if (Array.isArray(this.filtrosProduto[campo])) {
        this.$set(this.filtrosProduto, campo, []);
      } else {
        this.$set(this.filtrosProduto, campo, { min: null, max: null });
      }
      this.resetarPaginacao();
    },

    limparTodosFiltros() {
      Object.keys(this.filtrosGrupo).forEach(campo => {
        if (Array.isArray(this.filtrosGrupo[campo])) {
          this.filtrosGrupo[campo] = [];
        } else {
          this.filtrosGrupo[campo] = { min: null, max: null };
        }
      });

      Object.keys(this.filtrosProduto).forEach(campo => {
        if (Array.isArray(this.filtrosProduto[campo])) {
          this.filtrosProduto[campo] = [];
        } else {
          this.filtrosProduto[campo] = { min: null, max: null };
        }
      });

      Object.keys(this.ordenacaoPorCampo).forEach(campo => {
        this.ordenacaoPorCampo[campo] = null;
      });

      this.resetarPaginacao();
    },

    aplicarOrdenacao(campo, direcao) {
      for (const key in this.ordenacaoPorCampo) {
        if (key !== campo) {
          this.$set(this.ordenacaoPorCampo, key, null);
        }
      }

      this.$set(this.ordenacaoPorCampo, campo, direcao);

      const camposGrupo = ['nome', 'skus_ativos', 'skus_ruptura', 'necessidade', 'atendido', 'faltante', 'pct_skus', 'pct_rs'];

      if (camposGrupo.includes(campo)) {
        this.sortField = campo;
        this.sortAsc = direcao === 'asc';
      } else {
        this.sortProdField = campo;
        this.sortProdAsc = direcao === 'asc';
        this.paginasGrupo = {};
      }
    },

    aplicarFiltrosGrupos(grupos) {
      return grupos.filter(grupo => {
        if (this.filtrosGrupo.nome.length > 0) {
          const nomeMatch = this.filtrosGrupo.nome.some(termo =>
              grupo.nome.toLowerCase().includes(termo.toLowerCase())
          );
          if (!nomeMatch) return false;
        }

        const filtrosNumericos = ['skus_ativos', 'skus_ruptura', 'necessidade', 'atendido', 'faltante', 'pct_skus', 'pct_rs'];
        for (const campo of filtrosNumericos) {
          const filtro = this.filtrosGrupo[campo];
          if (filtro.min !== null && grupo[campo] < filtro.min) return false;
          if (filtro.max !== null && grupo[campo] > filtro.max) return false;
        }

        return true;
      });
    },

    aplicarFiltrosProdutos(produtos) {
      return produtos.filter(produto => {
        if (this.filtrosProduto.descricao_produto.length > 0) {
          const descMatch = this.filtrosProduto.descricao_produto.some(termo =>
              produto.descricao_produto.toLowerCase().includes(termo.toLowerCase())
          );
          if (!descMatch) return false;
        }

        if (this.filtrosProduto.data_movimento.length > 0) {
          if (!this.filtrosProduto.data_movimento.includes(produto.data_movimento)) {
            return false;
          }
        }

        if (this.filtrosProduto.origem.length > 0) {
          if (!this.filtrosProduto.origem.includes(produto.origem)) {
            return false;
          }
        }

        if (this.filtrosProduto.status_principal.length > 0) {
          if (!this.filtrosProduto.status_principal.includes(produto.status_principal)) {
            return false;
          }
        }

        const filtrosNumericos = ['custo_solicitado', 'custo_atendido', 'custo_faltante', 'percentual_atendido'];
        for (const campo of filtrosNumericos) {
          const filtro = this.filtrosProduto[campo];
          const valor = produto[campo] || 0;
          if (filtro.min !== null && valor < filtro.min) return false;
          if (filtro.max !== null && valor > filtro.max) return false;
        }

        return true;
      });
    },

    valoresUnicosGrupo(campo) {
      const valores = new Set();
      this.gruposRaiz.forEach(grupo => {
        if (grupo[campo] !== null && grupo[campo] !== undefined) {
          valores.add(grupo[campo]);
        }
      });
      return Array.from(valores).sort();
    },

    valoresUnicosProduto(campo) {
      const valores = new Set();
      this.produtos.forEach(produto => {
        if (produto[campo] !== null && produto[campo] !== undefined) {
          valores.add(produto[campo]);
        }
      });
      return Array.from(valores).sort();
    },

    agrupar(itens, nivelIdx) {
      if (nivelIdx >= this.niveisConfig.length) return [];
      const dim = this.niveisConfig[nivelIdx];
      const mapa = new Map();

      for (const p of itens) {
        const id   = p[dim.idF];
        const nome = p[dim.nomeF] || '(sem ' + dim.label.toLowerCase() + ')';
        const chave = id != null ? id : nome;
        if (!mapa.has(chave)) mapa.set(chave, { id: chave, nome, dim: dim.key, prods: [] });
        mapa.get(chave).prods.push(p);
      }

      return Array.from(mapa.values()).map(g => {
        const m = this.metricas(g.prods);
        return {
          tipo: 'grupo',
          uid:  `${g.dim}-${g.id}-n${nivelIdx}`,
          nivel: nivelIdx,
          nome: g.nome,
          dim:  g.dim,
          totalProdutos: g.prods.length,
          filhos: this.agrupar(g.prods, nivelIdx + 1),
          leafProds: nivelIdx === this.niveisConfig.length - 1 ? g.prods : [],
          ...m,
        };
      });
    },

    metricas(prods) {
      const ativos = prods.filter(p => !STATUS_EXCLUIDOS.has(p.status_principal));
      const skusAtivos  = new Set(ativos.map(p => p.subproduto_id)).size;
      const skusRuptura = new Set(ativos.filter(p => (p.qtd_faltante || 0) > 0).map(p => p.subproduto_id)).size;
      const necessidade = ativos.reduce((s, p) => s + (p.custo_solicitado || 0), 0);
      const atendido    = ativos.reduce((s, p) => s + (p.custo_atendido   || 0), 0);
      const faltante    = ativos.reduce((s, p) => s + (p.custo_faltante   || 0), 0);
      return {
        skus_ativos:  skusAtivos,
        skus_ruptura: skusRuptura,
        necessidade,
        atendido,
        faltante,
        pct_skus: skusAtivos  > 0 ? (skusRuptura / skusAtivos)  * 100 : 0,
        pct_rs:   necessidade > 0 ? (faltante    / necessidade)  * 100 : 0,
      };
    },

    achatar(grupos, linhas, nivel) {
      const ordenados = nivel === 0 ? grupos : this.ordenar(grupos);
      for (const g of ordenados) {
        linhas.push(g);
        if (!this.expandidos.has(g.uid)) continue;

        if (g.filhos && g.filhos.length) {
          this.achatar(g.filhos, linhas, nivel + 1);
        } else {
          const pagina  = this.paginasGrupo[g.uid] || 1;
          const produtosFiltrados = this.aplicarFiltrosProdutos(g.leafProds);
          const total   = produtosFiltrados.length;
          const totalPg = Math.max(1, Math.ceil(total / this.itensPorPagina));
          const inicio  = (pagina - 1) * this.itensPorPagina;

          const sf = this.sortProdField;
          const sm = this.sortProdAsc ? 1 : -1;

          const prodsOrdenados = [...produtosFiltrados].sort((a, b) => {
            const campoMap = {
              descricao_produto:   'descricao_produto',
              data_movimento:      'data_movimento',
              origem:              'origem',
              custo_solicitado:    'custo_solicitado',
              custo_atendido:      'custo_atendido',
              custo_faltante:      'custo_faltante',
              percentual_atendido: 'percentual_atendido',
              status_principal:    'status_principal',
            };
            const f = campoMap[sf] || sf;
            const va = a[f] ?? '';
            const vb = b[f] ?? '';
            return va < vb ? -sm : va > vb ? sm : 0;
          });
          const slice = prodsOrdenados.slice(inicio, inicio + this.itensPorPagina);

          linhas.push({
            tipo:     'subheader',
            uid:      `sh-${g.uid}`,
            nivel:    nivel + 1,
            grupoUid: g.uid,
            pagina,
            totalPg,
            total,
          });

          for (const p of slice) {
            linhas.push({
              tipo:             'produto',
              uid:              `prod-${p.subproduto_id}-${p.data_movimento}-${p.id_abastecimento ?? nivel}`,
              nivel:            nivel + 1,
              codigo:           p.codigo_produto,
              descricao:        p.descricao_produto,
              status_principal: p.status_principal,
              status_flags:     p.status_flags,
              origem:           p.origem,
              acao_comprador:   p.acao_comprador,
              data_mov:         p.data_movimento,
              custo_solicitado: p.custo_solicitado   || 0,
              custo_atendido:   p.custo_atendido     || 0,
              custo_faltante:   p.custo_faltante     || 0,
              pct_atendido:     p.percentual_atendido || 0,
              id_abastecimento: p.id_abastecimento,
              id_pedido:        p.id_pedido || null,
            });
          }

          if (totalPg > 1) {
            linhas.push({
              tipo:     'paginacao-grupo',
              uid:      `pg-${g.uid}`,
              nivel:    nivel + 1,
              grupoUid: g.uid,
              pagina,
              totalPg,
              total,
            });
          }
        }
      }
    },

    irParaPaginaFlat(p) {
      if (typeof p === 'number') this.paginaFlat = p;
    },

    irParaPaginaGrupo(uid, p) {
      if (typeof p === 'number') this.$set(this.paginasGrupo, uid, p);
    },

    resetarPaginacao() {
      this.paginaFlat   = 1;
      this.paginasGrupo = {};
    },

    ordenar(grupos) {
      const f = this.sortField;
      const m = this.sortAsc ? 1 : -1;
      return [...grupos].sort((a, b) => {
        const va = f === 'nome' ? a.nome : (a[f] ?? 0);
        const vb = f === 'nome' ? b.nome : (b[f] ?? 0);
        return va < vb ? -m : va > vb ? m : 0;
      });
    },

    toggleExpandido(uid) {
      const s = new Set(this.expandidos);
      s.has(uid) ? s.delete(uid) : s.add(uid);
      this.expandidos = s;
    },

    colapsarTodos() {
      this.expandidos = new Set();
    },

    fmt(v) {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);
    },

    fmtPct(v) {
      return `${(v || 0).toFixed(1)}%`;
    },

    pctColor(v) {
      if (v >= 40) return '#dc2626';
      if (v >= 25) return '#ea580c';
      if (v >= 10) return '#d97706';
      return '#16a34a';
    },

    pctCls(v) {
      if (v >= 40) return 'pct-high';
      if (v >= 25) return 'pct-med';
      if (v >= 10) return 'pct-low';
      return 'pct-ok';
    },

    statusLabel(s) {
      if (!s) return '?';
      if (s === 'FORA DE LINHA') return 'Fora de Linha';
      if (s === 'CORTADO - Sem Estoque CD') return 'Sem Estoque CD';
      if (s === 'RUPTURA TOTAL') return 'Rupt. Total';
      if (s === 'RUPTURA PARCIAL') return 'Rupt. Parcial';
      if (s === 'ATENDIDO OK') return 'OK';
    if (s.includes('SUGERIDO')) return 'Suges. Ignorada';
      return s;
    },

    statusColor(s) {
      if (!s) return '#64748b';
      if (s === 'FORA DE LINHA') return '#64748b';
      if (s === 'CORTADO - Sem Estoque CD') return '#f59e0b';
      if (s === 'RUPTURA TOTAL') return '#dc2626';
      if (s === 'RUPTURA PARCIAL') return '#d97706';
      if (s === 'ATENDIDO OK') return '#16a34a';
      if (s.includes('SUGERIDO')) return '#6366f1';
      return '#64748b';
    },
  },
};
</script>

<style scoped>
.rupturas-hierarquia {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>